module.exports = __webpack_public_path__ + "fonts/e8f8260f-dbee-4daa-81a4-0e415715c569.fe2b513.ttf";